export default __webpack_public_path__ + "static/media/references__italier.f36b3162.jpg";